import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayReportIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 18.84H19.65L18.84 9.57999C18.62 7.10999 16.59 5.23999 14.11 5.23999H9.89C7.41 5.23999 5.37 7.09999 5.16 9.57999L4.35 18.84H3C2.59 18.84 2.25 19.18 2.25 19.59V23C2.25 23.41 2.59 23.75 3 23.75H21C21.41 23.75 21.75 23.41 21.75 23V19.59C21.75 19.18 21.41 18.84 21 18.84ZM6.65 9.71999C6.8 8.02999 8.19 6.74999 9.89 6.74999H14.11C15.81 6.74999 17.2 8.02999 17.35 9.71999L18.15 18.84H5.85L6.65 9.71999ZM20.25 22.25H3.75V20.34H20.25V22.25Z"
        fill={color}
      />
      <path
        d="M11 8.25H9.89C8.98 8.25 8.23 8.94 8.15 9.85L7.97 11.94C7.93 12.35 8.24 12.72 8.65 12.75C9.06 12.79 9.43 12.48 9.46 12.07L9.64 9.98C9.65 9.85 9.76 9.75 9.89 9.75H11C11.41 9.75 11.75 9.41 11.75 9C11.75 8.59 11.41 8.25 11 8.25Z"
        fill={color}
      />
      <path
        d="M12 3.5C12.41 3.5 12.75 3.16 12.75 2.75V0.75C12.75 0.34 12.41 0 12 0C11.59 0 11.25 0.34 11.25 0.75V2.75C11.25 3.16 11.59 3.5 12 3.5Z"
        fill={color}
      />
      <path
        d="M4.28 4.84003C4.57 5.13003 5.05 5.13003 5.34 4.84003C5.63 4.55003 5.63 4.07003 5.34 3.78003L3.93 2.37003C3.64 2.08003 3.16 2.08003 2.87 2.37003C2.58 2.66003 2.58 3.14003 2.87 3.43003L4.28 4.84003Z"
        fill={color}
      />
      <path
        d="M4 10.5C4 10.09 3.66 9.75 3.25 9.75H1.25C0.84 9.75 0.5 10.09 0.5 10.5C0.5 10.91 0.84 11.25 1.25 11.25H3.25C3.66 11.25 4 10.91 4 10.5Z"
        fill={color}
      />
      <path
        d="M19.72 4.84003L21.13 3.43003C21.42 3.14003 21.42 2.66003 21.13 2.37003C20.84 2.08003 20.36 2.08003 20.07 2.37003L18.66 3.78003C18.37 4.07003 18.37 4.55003 18.66 4.84003C18.95 5.13003 19.43 5.13003 19.72 4.84003Z"
        fill={color}
      />
      <path
        d="M22.75 9.75H20.75C20.34 9.75 20 10.09 20 10.5C20 10.91 20.34 11.25 20.75 11.25H22.75C23.16 11.25 23.5 10.91 23.5 10.5C23.5 10.09 23.16 9.75 22.75 9.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayReportIcon.displayName = 'PayReportIcon';
